export interface TPAComponentProps {
  /**
   * Class Name to pass to the root of the component
   */
  className?: string;
  /**
   * A data-hook attribute to pass to the root of the component
   */
  'data-hook'?: string;
}

export interface RequiredProps {
  /** Whether selection is required */
  required?: boolean;
  /** Whether to display an asterisk, applicable only when required is true */
  showAsterisk?: boolean;
}

export interface LangProps {
  /** Specifies the language for the element, using a valid BCP 47 language tag. */
  lang?: string;
}

export type Omit<T, K extends keyof any> = Pick<T, Exclude<keyof T, K>>;
